import { AvatarWithFallbackProps } from './avatar-with-fallback';

const config = {
  green: {
    textColor: 'var(--brand-dark)',
    backgroundColor: 'var(--brand-light)',
  },
  blue: {
    textColor: 'var(--secondary-blue-dark)',
    backgroundColor: 'var(--secondary-blue-light)',
  },
  purple: {
    textColor: 'var(--secondary-purple-dark)',
    backgroundColor: 'var(--secondary-purple-light)',
  },
  red: {
    textColor: 'var(--attention-dark)',
    backgroundColor: 'var(--attention-light)',
  },
  orange: {
    textColor: 'var(--secondary-orange-dark)',
    backgroundColor: 'var(--secondary-orange-light)',
  },
  turquoise: {
    textColor: 'var(--secondary-green-dark)',
    backgroundColor: 'var(--secondary-green-light)',
  },
  default: {
    textColor: 'var(--text-primary)',
    backgroundColor: 'var(--control-minor)',
  },
};

export const convertTextColor = (color: AvatarWithFallbackProps['color']) => {
  if (!color) return config.default.textColor;
  return config[color].textColor;
};

export const convertBackgroundColor = (color: AvatarWithFallbackProps['color']) => {
  if (!color) return config.default.backgroundColor;
  return config[color].backgroundColor;
};
